import {
  callMemberPointCardInquiry,
  callPointCardLink
} from 'features/smart-receipt/api';
import { LINK_SUCCESS_PAGE_PATH } from 'features/smart-receipt/pages';
import { ResponseError } from 'libs/features-api';

interface SubmitResult {
  redirectPath: string | null;
  toastText: string | null;
}

export const handleLinkFormSubmit = async (params: {
  accountId: string;
  plainPassword: string;
}): Promise<SubmitResult> => {
  const { accountId, plainPassword } = params;

  try {
    // 連携済みかどうかを確認して、スマレシアカウントのブルートフォースアタックを軽減させる
    // @see https://github.com/voyagegroup/digiclue-features/blob/619f2f3b829172f5ddcb2b35870615ba39257822/app/controllers/api/v1/line/smart_receipt/users/current/point_card_links_controller.rb#L14-L42
    const isAlreadyLinked = await callMemberPointCardInquiry();
    if (isAlreadyLinked) {
      return {
        redirectPath: LINK_SUCCESS_PAGE_PATH,
        toastText: 'すでにスマートレシートと連携済みです。'
      };
    }

    // 仮に連携済みの状態でAPIを実行しても、スマレシ側は「既存連携アリ」のレスポンスを返す
    // なので、表向きは冪等な挙動をしているのでガードは頑張らなくてOK
    const isSucceeded = await callPointCardLink({
      accountId,
      plainPassword
    });
    if (isSucceeded) {
      return {
        redirectPath: LINK_SUCCESS_PAGE_PATH,
        toastText: 'スマートレシートの連携に成功しました。'
      };
    } else {
      return {
        redirectPath: null,
        toastText: '入力内容に不備があります。修正して再度お試しください。'
      };
    }
  } catch (error) {
    if (error instanceof ResponseError && error.status === 404) {
      // 運用中にスマレシ設定を「無効」にするなどのケースで発生する
      // 通常運用ではありえないので、何もせず404ページに飛ばす
      return {
        redirectPath: '/not-found',
        toastText: null
      };
    } else {
      return {
        redirectPath: null,
        toastText:
          'エラーが発生しました\nしばらく時間をおいて再度お試しください。'
      };
    }
  }
};
